<template>
  <v-row>
    <v-col cols="12" md="3">
      <v-card outlined>
        <div class="pa-4">
          <v-img height="130" :src="material.imagen" contain content-class="py-5">
          </v-img>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" md="9">
      <v-row>
        <v-col class="pa-0">
          <v-text-field readonly :value="material.marca" :label="$t('label_marca')" hide-details/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-text-field readonly :value="material.coleccion" :label="$t('label_colec')" hide-details/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-text-field readonly :value="material.enlace" :label="$t('label_enlace')" hide-details/>
        </v-col>
      </v-row>
      <v-row class="pb-0">
        <v-col class="primary--text font-weight-bold px-0 pt-6">{{ $t("descrip_producto") }}</v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-text-field readonly
                        :value="material.ceramicos.length > 0 ? material.ceramicos[0].nombre : material.noCeramicos[0].nombre"
                        :label="$t('label_material')" hide-details/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-text-field readonly :value="material.formato" :label="$t('label_formato')" hide-details/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pa-0">
          <v-text-field readonly :value="material.espesor" :label="$t('label_espesor')" hide-details/>
        </v-col>
      </v-row>
      <v-row v-if="material.absorcionAgua">
        <v-col class="pa-0">
          <v-text-field readonly :value="material.absorcionAgua.nombre" :label="$t('absorcion_agua')" hide-details/>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "VisualizarMaterialPersonalizado",
  props: {
    material: {required: true, type: Object}
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "descrip_empresa": "Información de la empresa",
    "descrip_producto": "Descripción del producto",
    "label_material": "Material:",
    "label_marca": "Marca:",
    "label_colec": "Colección - Pieza:",
    "label_enlace": "Enlace web:",
    "label_formato": "Formato (cm):",
    "label_espesor": "Espesor (mm):",
    "absorcion_agua": "Absorción de agua"
  }
}
</i18n>
<!--@formatter:on-->